// Custom Checkout Redirect Script
(function() {
    // Function to replace checkout URLs
    function replaceCheckoutUrls() {
        // Find all links and buttons that might contain checkout URLs
        const elements = document.querySelectorAll('a[href*="/checkouts/"], button[formaction*="/checkouts/"], form[action*="/checkouts/"]');
        
        elements.forEach(element => {
            if (element.tagName === 'A') {
                // Replace the href attribute for links
                element.href = element.href.replace(/\/checkouts\/.*/, '/pages/checkout');
            } else if (element.tagName === 'BUTTON') {
                // Replace the formaction attribute for buttons
                element.formAction = element.formAction.replace(/\/checkouts\/.*/, '/pages/checkout');
            } else if (element.tagName === 'FORM') {
                // Replace the action attribute for forms   
                element.action = element.action.replace(/\/checkouts\/.*/, '/pages/checkout');
            }
        });
    }

    // Run the function when the DOM is fully loaded
    document.addEventListener('DOMContentLoaded', replaceCheckoutUrls);

    // Also run the function when the page content changes (for dynamic content)
    const observer = new MutationObserver(function(mutations) {
        replaceCheckoutUrls();
    });

    // Start observing the document body for changes
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
})(); 